import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { generateAttendance as _generateAttendance, saveItemInfo, payrollSubStaffList as _payrollSubStaffList, getListHeaderColumns, payrollKaoqinDownFn, downloadStaffPayInfoTplNew, exportTaxExcel,
// 子项目-批量修改税-模版
clearSalaryMonthTax // 子项目-清空所有员工的税
} from '@/api/payroll';
// 上传
import uploadDialog from '@/views/payroll/compontents/uploadSelf';
import Pagination from '@/components/pagination';
import allTable from './components/all-info';
import SalaryStorageSettingDialog from './components/salary-storage-setting-dialog.vue';
import { info, common, NetPay } from './column.js';
export default {
  props: {
    activeData: {
      type: Object
    }
  },
  components: {
    Pagination: Pagination,
    uploadDialog: uploadDialog,
    allTable: allTable,
    SalaryStorageSettingDialog: SalaryStorageSettingDialog
  },
  data: function data() {
    return {
      projectId: this.$route.params.id,
      showSalaryStorageSetting: false,
      isIndeterminate: false,
      checkAll: true,
      columnInfo: info,
      currentColumn: [],
      // 表头
      tableData: {},
      edit: false,
      generateLoad: false,
      requestParams: {
        // 请求参数
        page: 1,
        page_size: 20,
        search_word: '',
        data_type: 'all' // tabs栏控制
      },

      page: {
        pageSizes: [20, 50, 100],
        total: 0,
        currentPage: 1
      },
      visible: false,
      // 编辑窗口展示
      sort: '',
      dir: '',
      importList: [],
      // 模版列表
      kaoqinImportList: [],
      taxImport: [],
      tableCloumns: [],
      visibleTax: false,
      taxModule: '0',
      taxAdjusted: {
        0: this.$t('payroll_wage_36'),
        1: this.$t('payroll_wage_37'),
        2: this.$t('payroll_wage_38')
      },
      resultParams: {
        allname: 'upload_total_count',
        successName: 'upload_success_count',
        errorNum: 'upload_fail_count'
      },
      cloneRow: {}
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.importList = [{
      name: this.$t('650'),
      method: function method() {
        return _this.download('month');
      }
    }];
    this.kaoqinImportList = [{
      name: this.$t('650'),
      method: function method() {
        return _this.kaoqinDownload();
      }
    }];
    this.taxImport = [{
      name: this.$t('650'),
      method: function method() {
        return _this.taxDownload();
      }
    }];
  },
  created: function created() {
    this.init();
  },
  watch: {
    tableData: {
      handler: function handler(val) {
        this.$emit('changeList', val.list);
      },
      deep: true,
      immediate: true
    },
    currentColumn: {
      handler: function handler(v) {
        var _this2 = this;
        // this.activeData.info.settlement_type 1月结 2日结 3其他 99其他
        this.tableCloumns = v.filter(function (item) {
          return item.isShow ? item.isShow.includes(Number(_this2.activeData.info.settlement_type)) : true;
        });
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    init: function init() {
      this.payrollSubStaffList(); // 获取表格列表信息
      this.loadSubStaffColumns();
    },
    // get_income_type_column() {
    //   const res = []
    //   if (+this.activeData?.info.tax_deduction_status === 4) {
    //     res.push({
    //       label: this.$t('1980'),
    //       prop: 'income_type',
    //       // 1月结 2日结
    //       isShow: [1, 2],
    //       align: 'left',
    //       width: '200px'
    //     })
    //   }
    //   return res
    // },
    loadSubStaffColumns: function loadSubStaffColumns() {
      var _this3 = this;
      this.currentColumn = [];
      getListHeaderColumns({
        sub_project_id: this.projectId,
        active: 2
      }).then(function (res) {
        _this3.currentColumn = [].concat(_toConsumableArray(common), _toConsumableArray(res.data), _toConsumableArray(NetPay));
        _this3.currentColumn[0].width = '264';
        _this3.edit = res.data.some(function (item) {
          return item.edit === true;
        });
        if (_this3.currentColumn.length === 2) {
          _this3.currentColumn[0].width = 'auto';
        }
      });
    },
    payrollSubStaffList: function payrollSubStaffList() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var msg, res, data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // 请求列表数据
              msg = _objectSpread(_objectSpread({
                sort: _this4.sort,
                // 排序相关
                dir: _this4.dir
              }, _this4.requestParams), {}, {
                sub_project_id: _this4.projectId
              });
              _context.next = 3;
              return _payrollSubStaffList(msg);
            case 3:
              res = _context.sent;
              data = res.data;
              _this4.tableData = res.data;
              _this4.page.total = data.count;
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    handlerSort: function handlerSort(_ref) {
      var prop = _ref.prop,
        order = _ref.order;
      // 排序
      this.sort = prop;
      this.dir = order;
      this.payrollSubStaffList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.requestParams.page = val;
      this.payrollSubStaffList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.requestParams.page = 1;
      this.requestParams.page_size = val;
      this.payrollSubStaffList();
    },
    handleEdit: function handleEdit(row, status, scope, save) {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var msg, res, r, data;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(!save && !status)) {
                _context2.next = 4;
                break;
              }
              // 取消
              row = JSON.parse(JSON.stringify(_this5.cloneRow.children));
              _context2.next = 19;
              break;
            case 4:
              if (!(save && !status)) {
                _context2.next = 13;
                break;
              }
              delete row.children;
              msg = {
                sub_project_id: _this5.projectId,
                staff_id: row.staff_info_id,
                list: row
              }; // 保存操作
              _context2.next = 9;
              return saveItemInfo(msg);
            case 9:
              res = _context2.sent;
              row = res.data.list;
              _context2.next = 19;
              break;
            case 13:
              r = JSON.parse(JSON.stringify(row)); // 开启编辑
              _this5.$set(_this5, 'cloneRow', _objectSpread(_objectSpread({}, r), {}, {
                children: r
              }));
              data = JSON.parse(JSON.stringify(row));
              _this5.tableCloumns.forEach(function (item) {
                if (item.edit) {
                  // const str = String(data[item.prop]).replace(/,/gi, '')
                  // const num = Number(str)
                  // data[item.prop] = isNaN(num) ? '' : num
                  var str = String(data[item.prop]).replace(/,/gi, '');
                  // const num = Number(str)
                  data[item.prop] = isNaN(str) ? '' : str;
                }
              });
              data.children = JSON.parse(JSON.stringify(data));
              row = data;
            case 19:
              row.edit = status;
              _this5.$set(_this5.tableData.list, scope.$index, row);
            case 21:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    // 模版上传成功回掉
    onSuccess: function onSuccess(res) {
      if (res.code === 0) {
        this.$notify({
          title: this.$t('229'),
          message: res.message,
          type: 'warning'
        });
        return false;
      }
      if (res.data && res.data.object_url) window.location.href = res.data.object_url;
      if (res.data && res.data.feedback_file_url) window.location.href = res.data.feedback_file_url;
      this.payrollSubStaffList();
    },
    // 上传组件展示
    handleUploadClick: function handleUploadClick() {
      // 上传薪资导入项
      this.$refs.upload.init();
    },
    download: function download() {
      var _this6 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return downloadStaffPayInfoTplNew({
                sub_project_id: _this6.projectId
              });
            case 2:
              res = _context3.sent;
              if (res.data && res.data.object_url) window.location.href = res.data.object_url;
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    kaoqinDownload: function kaoqinDownload() {
      var _this7 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var res;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return payrollKaoqinDownFn({
                sub_project_id: _this7.projectId
              });
            case 2:
              res = _context4.sent;
              if (res.data && res.data.object_url) window.location.href = res.data.object_url;
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    taxDownload: function taxDownload() {
      var _this8 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var res;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return exportTaxExcel({
                sub_project_id: _this8.projectId
              });
            case 2:
              res = _context5.sent;
              if (res.data && res.data.url) window.location.href = res.data.url;
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    handleTax: function handleTax(key, item) {
      var _this9 = this;
      // 调整税额
      if (this.taxModule !== key) this.taxModule = key;
      this.visibleTax = false;
      if (key === '1') {
        // 清空税额
        this.$confirm(this.$t('payroll_wage_40'), '', {
          confirmButtonText: this.$t('submit_btn'),
          cancelButtonText: this.$t('cancel_btn'),
          type: 'warning'
        }).then(function () {
          clearSalaryMonthTax({
            sub_project_id: _this9.projectId
          }).then(function (res) {
            if (res.code === 1 && res.data) {
              _this9.$message.success(res.message);
              _this9.payrollSubStaffList();
            }
          });
        }).catch(function () {
          _this9.taxModule = '0';
        });
      } else {
        // 批量调整
        this.$refs.taxUpload.init();
      }
    },
    doSubmit: function doSubmit() {
      this.taxModule = '0';
    },
    handleKaoqinUploadClick: function handleKaoqinUploadClick() {
      // 导入考勤
      this.$refs.kaoqinUpload.init();
    },
    handleMoreClick: function handleMoreClick() {
      this.showSalaryStorageSetting = true;
    },
    handleSalaryStorageSaved: function handleSalaryStorageSaved() {
      // 保存叶子字段后刷新表头/数据展示
      this.loadSubStaffColumns();
      this.payrollSubStaffList();
    },
    generateAttendance: function generateAttendance() {
      var _this10 = this;
      // 同步考勤
      this.generateLoad = true;
      _generateAttendance({
        sub_project_id: this.projectId
      }).then(function (res) {
        if (res && res.code === 1) {
          _this10.payrollSubStaffList();
          _this10.$notify({
            title: _this10.$t('818'),
            message: _this10.$t('886'),
            type: 'success'
          });
        }
      }).finally(function () {
        _this10.generateLoad = false;
      });
    }
  }
};